<template>
  <b-modal
    ref="modalEventCalendar"
    size="xs"
    centered
    modal-class="modal-event-calendar"
    @hidden="hide"
  >
    <div slot="modal-title">
      <span v-if="isRequested">{{ $t('component.calendar.update') }} </span>
      <span v-if="!isRequested">{{ $t('component.calendar.request') }} </span>
      <span>{{ $tc('component.calendar.event', 1) }}</span>
    </div>
    <b-row class="px-3 py-2">
      <b-col
        v-if="isManager"
        class="mb-3"
        cols="12"
      >
        <div class="form-label">
          <label>{{ $t('Usuario') }}</label>
        </div>
        <vt-combo-select
          v-model="userSelected"
          v-validate="'required'"
          class="nowrap"
          :class="{ requiredform: (showErrors && !userSelected) }"
          track-by="id"
          :option-loader="getPersonnel"
          :allow-empty="false"
          label="fullName"
        />
      </b-col>
      <b-col
        class="mb-3"
        cols="12"
      >
        <div class="form-label">
          <label>{{ $t('component.calendar.eventType') }}</label>
        </div>
        <vt-combo-select
          v-model="eventTypeSelected"
          v-validate="'required'"
          class="nowrap"
          :class="{ requiredform: (showErrors && !eventTypeSelected) }"
          :option-loader="getAllPersonnelEventTypes"
          track-by="code"
          label="translatedName"
          :allow-empty="false"
        />
      </b-col>
      <b-col cols="12">
        <div class="form-label">
          <label>{{ $t('component.calendar.startDate') }}</label>
        </div>
        <vt-date-picker
          :model="startDateSelected"
          :class="{ requiredform: (showErrors && !startDateSelected) }"
          class="p-0"
          type="date"
          :not-after="endDateSelected"
          @update="startDateSelected = $event"
          @clear="startDateSelected = null"
        />
      </b-col>
      <b-col
        cols="12"
        class="mt-3"
      >
        <div class="form-label">
          <label>{{ $t('configuration.modal.calendar.endDate') }}</label>
        </div>
        <vt-date-picker
          :model="endDateSelected"
          :class="{ requiredform: (showErrors && !endDateSelected) }"
          class="p-0"
          type="date"
          :not-before="startDateSelected"
          @update="endDateSelected = $event"
          @clear="endDateSelected = null"
        />
      </b-col>
      <b-col
        cols="12"
        class="mt-3"
      >
        <div class="form-label">
          <label>{{ $t('global.observations') }}</label>
        </div>
        <vt-input
          v-model="observations"
          name="eventObservations"
          class="form-control-sm"
        />
      </b-col>
    </b-row>
    <div
      slot="modal-footer"
      class="footer-banner px-2"
      style="width:100%;"
    >
      <div class="row">
        <div class="col-auto text-left">
          <b-button
            size="sm"
            variant="outline-secondary"
            data-dismiss="modal"
            @click="hide"
          >
            {{ $t('global.cancel') }}
          </b-button>
        </div>
        <div class="col text-right">
          <b-button
            v-if="selectedEventId"
            size="sm"
            class="btn__outline mr-2"
            @click="deletePersonnelEvent"
          >
            <i
              class="fal fa-trash-alt mr-2"
              aria-hidden="true"
            />
            {{ $t('configuration.actions.delete') }}
          </b-button>
          <b-button
            v-if="!selectedEventId"
            size="sm"
            class="btn--primary"
            @click="createUpdatePersonnelEvent"
          >
            <i
              class="fal fa-check mr-2"
              aria-hidden="true"
            />
            {{ $t('component.calendar.request') }}
          </b-button>
          <b-button
            v-if="selectedEventId"
            size="sm"
            class="btn--primary"
            @click="createUpdatePersonnelEvent"
          >
            <i
              class="fal fa-check mr-2"
              aria-hidden="true"
            />
            {{ $t('component.calendar.update') }}
          </b-button>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>

import { personnelService } from '@/api/resources/personnelService'
import { EVENT_TYPE } from '@/api/resources/personnelEvents/constants/eventType'
import moment from 'moment'
import PersonnelEventTypesServices
    from '@/api/resources/personnelEvents/personnelEventTypes/personnelEventTypesServices'

export default {
    name: 'ModalEventCalendar',
    props: {
        isManager: { type: Boolean, default: false }
    },
    data() {
        return {
            eventTypeSelected: null,
            isRequested: false,
            userSelected: null,
            startDateSelected: null,
            observations: '',
            endDateSelected: null,
            showErrors: false,
            selectedEventId: null
        }
    },
    computed: {
        laboratoryId() {
            return this.$store.getters.labId
        },
        EVENT_TYPE() {
            return EVENT_TYPE
        }
    },
    methods: {
        show(selectedEvent) {
            this.$_cleanComponentData()
            if (selectedEvent) {
                this.selectedEventId = selectedEvent.id
                this.eventTypeSelected = selectedEvent.type
                this.userSelected = selectedEvent.personnel
                this.observations = selectedEvent.observations
                this.startDateSelected = moment(selectedEvent.startingDate)
                this.endDateSelected = moment(selectedEvent.endingDate)
            }
            this.$refs.modalEventCalendar.show()
        },
        hide() {
            this.$refs.modalEventCalendar.hide()
        },
        async deletePersonnelEvent() {
            this.$emit('deleteEvent', [this.$data])
            this.hide()
        },
        async createUpdatePersonnelEvent() {
            const validForm = await this.$validator.validate()
            const validDateRange = this.startDateSelected && this.endDateSelected
            if (validForm && validDateRange) {
                if (!this.selectedEventId) {
                    this.$emit('createEvent', this.$data)
                } else {
                    this.$emit('updateEvent', this.$data)
                }
                this.hide()
            } else {
                this.showErrorModalGlobal(this.$t('studyRequest.general.requiredFieldsNotice'))
                this.showErrors = true
            }
        },
        async getPersonnel() {
            return personnelService.getPersonnel(this.laboratoryId)
        },
        async getAllPersonnelEventTypes() {
            return PersonnelEventTypesServices.getAllPersonnelEventTypesDays()
        }
    }
}
</script>

<style lang="scss">
    .requiredform {
          border-color: red !important;
    }
</style>
